export default defineNuxtPlugin(() => {
  const placeholderSrc = "/placeholder.png";

  const onImageError = (event: Event) => {
    const target = event.target;
    if (
      !(target instanceof HTMLImageElement) ||
      target.hasAttribute("data-school-brand-logo")
    ) {
      return;
    }

    const currentSrc = target.currentSrc || target.src;
    if (currentSrc.includes(placeholderSrc)) {
      return;
    }

    target.dataset.fallbackApplied = "true";
    target.src = placeholderSrc;
    target.srcset = "";
  };

  document.addEventListener("error", onImageError, true);
});
